import type { DriverPaceRow } from '../../services/analytics.api';
import { Panel } from '../ui/Panel';
import { cn } from '../../utils/cn';

const FAST = { dot: 'bg-emerald-500', chip: 'bg-emerald-50 text-emerald-700' };
const NORMAL = { dot: 'bg-gray-400', chip: 'bg-gray-100 text-gray-600' };
const SLOW = { dot: 'bg-red-500', chip: 'bg-red-50 text-red-700' };

const KEY = [
  { label: 'Fast ≤ 15 s/pkg', tone: FAST },
  { label: 'Normal ≤ 30 s', tone: NORMAL },
  { label: 'Slow > 30 s', tone: SLOW },
];

function toneFor(s: number) {
  return s <= 15 ? FAST : s <= 30 ? NORMAL : SLOW;
}

export default function DriverScanPace({ drivers }: { drivers: DriverPaceRow[] }) {
  return (
    <Panel title="Driver scan pace" subtitle="Pickups with 25+ orders only — a fair comparison">
      {drivers.length === 0 ? (
        <p className="text-[13px] text-gray-500">Not enough big pickups in this window.</p>
      ) : (
        <>
          <p className="mb-3 flex flex-wrap gap-x-4 gap-y-1 text-[12px] text-gray-500">
            {KEY.map((k) => (
              <span key={k.label} className="inline-flex items-center gap-1.5">
                <span aria-hidden className={cn('h-2 w-2 rounded-full', k.tone.dot)} />
                {k.label}
              </span>
            ))}
          </p>
          <div className="flex flex-wrap gap-2">
            {drivers.map((d) => {
              const tone = toneFor(d.per_package_p50_s);
              return (
                <span
                  key={d.driver_id}
                  className={cn(
                    'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[13px] tabular-nums',
                    tone.chip
                  )}
                >
                  <span aria-hidden className={cn('h-1.5 w-1.5 rounded-full', tone.dot)} />
                  {`Driver #${d.driver_id} · ${d.per_package_p50_s} s · ${d.legs} legs`}
                </span>
              );
            })}
          </div>
        </>
      )}
    </Panel>
  );
}
